import AnimSearchGlass from '@/js/components/anim_search_glass/animSearchGlass';

// eslint-disable-next-line no-new
new AnimSearchGlass();
